<ng-template #timeoutWarningContent>
  <span>
    Your session is about to expire. You will be logged out in
    <span class="kh-time-remaining">{{ formattedSecondsRemaining() }}</span
    ><br />
  </span>
  <span>To stay logged in, select “Continue Session”.</span>
</ng-template>
